import { learnerPromptTypes, type LearnerPromptType } from './card-history'
type QuestionLikeBlock = { qid: string; fractionalIndex: string; importance?: string; difficulty?: string; promptType?: string; type?: string; subtype?: string }
export function readImportance(block: QuestionLikeBlock) {
  const value = 'importance' in block ? block.importance : undefined
  return value === 'low' || value === 'high' ? value : 'medium'
}

export function readDifficulty(block: QuestionLikeBlock) {
  const value = 'difficulty' in block ? block.difficulty : undefined
  return value === 'low' || value === 'high' ? value : 'medium'
}

/** Authored family comes from grading shape; old strategy metadata is ignored. */
export function readPromptType(block: QuestionLikeBlock): LearnerPromptType {
  if (block.type === 'cloze' || block.type === 'rule') return 'cloze'
  const families: Record<string, LearnerPromptType> = { sa: 'short-answer', la: 'long-answer', sc: 'single-choice', mc: 'multiple-choice', sr: 'spoken-response' }
  return families[block.subtype ?? ''] ?? (learnerPromptTypes.includes(block.promptType as LearnerPromptType) ? block.promptType as LearnerPromptType : 'short-answer')
}
